import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';

export default class PenaltiesRoute extends Route 
{
	@service resultsAjax;
	@service store;
	
	model(params) 
	{
		var event_id = this.modelFor('event').id;
		
		var store = this.store;
		
		return this.resultsAjax.request("/events/"+event_id+"/results/individualsSplits").then(function(results)
		{
			results.forEach(function(result)
			{
				store.findRecord('class',result.data.relationships.ClassId.data.id);
				store.pushPayload(result);
			});
		}).then(function()
		{
			return store.findRecord('Event', event_id);
		});
	}
}